import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  ButtonsContainer,
  ButtonWithLoader,
  Paper,
  PaperTitle,
  FormWrapper,
  Col,
  InlineFormRow,
  RFFormInput,
} from 'virtues-bootstrap';
import { compose } from 'ramda';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

import { FORM_NAMES } from 'constants/forms';

import validate from './validatePassword';

import s from './styles.module.scss';

const ResetPatientsPassword = ({ pristine, patientId, submitting, t, handleSubmit }) => (
  <form onSubmit={handleSubmit} autoComplete="off">
    <Paper>
      <PaperTitle withBorder>{t('addPatient.resetPassword')}</PaperTitle>
      <FormWrapper>
        <InlineFormRow label={t('addPatient.patientNewPassword')} labelRequired>
          <Col xs={7}>
            <Field
              spellCheck={false}
              className={s.passField}
              autoComplete="off"
              component={RFFormInput}
              name="password"
              placeholder="••••••••"
              type="text"
            />
          </Col>
        </InlineFormRow>
        <InlineFormRow label={t('addPatient.confirmNewPassword')} labelRequired>
          <Col xs={7}>
            <Field
              spellCheck={false}
              className={s.passField}
              autoComplete="off"
              component={RFFormInput}
              name="confirmPassword"
              placeholder="••••••••"
              type="text"
            />
          </Col>
        </InlineFormRow>
      </FormWrapper>
    </Paper>
    <ButtonsContainer>
      <Button component={Link} to={`/patient/${patientId}`} variant="link">
        {t('buttons.cancel')}
      </Button>
      <ButtonWithLoader disabled={pristine} loading={submitting}>
        {t('addPatient.saveChanges')}
      </ButtonWithLoader>
    </ButtonsContainer>
  </form>
);

ResetPatientsPassword.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  patientId: PropTypes.string.isRequired,
  submitting: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

export default compose(
  withTranslation(),
  reduxForm({
    form: FORM_NAMES.editPatientChangePass,
    validate,
  }),
)(ResetPatientsPassword);
